'use client'
import CouponBar from './CouponBar'

type Region = 'cz' | 'pl' | 'de'

const getCommonNinjaIdsEnv = (region: Region): string | undefined => {
  switch (region) {
    case 'de':
      return process.env.NEXT_PUBLIC_DE_COMMONNINJA_WIDGETS_IDS
    case 'cz':
      return process.env.NEXT_PUBLIC_CZ_COMMONNINJA_WIDGETS_IDS
    case 'pl':
    default:
      return process.env.NEXT_PUBLIC_PL_COMMONNINJA_WIDGETS_IDS
  }
}

const getIds = (region: Region) => {
  const raw = getCommonNinjaIdsEnv(region)
  return (
    raw
      ?.split(';')
      .map(s => s.trim())
      .filter(Boolean) ?? []
  )
}

export function CouponBarWidgets({ region }: { region: Region }) {
  const ids = getIds(region)
  return (
    <div className={`coupon-bar-provider-${region}`}>
      <CouponBar widgetIds={ids} />
    </div>
  )
}
